import {
  addPageAction,
  captureException as newrelicCaptureException,
} from '@/newrelic'

import { container, TYPES } from '@/libs/di/inversify.config'
import type { APIConfig } from '@/apis/infrastructures'
import { useWebSocket } from '@vueuse/core'

type onUpdateChatRoom = (chatRoomId: string[]) => void

export function useUpdatedChatRoom(
  plannerID: string,
  entranceGUID: string,
  onUpdateChatRoom: onUpdateChatRoom,
  onConnected?: () => void
) {
  const config = container.get<APIConfig>(TYPES.APIConfig)
  if (!config.apiToken) return

  const query = entranceGUID.length > 0 ? `?entrance-guid=${entranceGUID}` : ''
  // https://vueuse.org/core/usewebsocket/
  useWebSocket(`${config.cinnamonWsUrl}/ws/planner/${plannerID}${query}`, {
    protocols: [encodeURIComponent(config.apiToken.toString())],
    autoReconnect: {
      retries: 10,
      delay: 5000,
      onFailed() {
        addPageAction('websocketRetryExhausted', { retries: 10 })
      },
    },
    onMessage: (_, event) => {
      try {
        const data = JSON.parse(event.data) as { room_ids: number[] }
        onUpdateChatRoom(data.room_ids.map(id => id.toString()))
      } catch (e) {
        newrelicCaptureException(e)
      }
    },
    onConnected: () => {
      onConnected?.()
    },
  })
}
